export const crispdramatic = {
  name: 'Crisp & Dramatic',
  color: [0.40784313725490196, 0.5098039215686274, 0.6196078431372549, 1],
  bg: [0.3137254901960784, 0.3176470588235294, 0.3764705882352941, 1],
  grid1: [0.6823529411764706, 0.7411764705882353, 0.2196078431372549, 1],
  grid2: [0.34901960784313724, 0.5098039215686274, 0.20392156862745098, 1],
}
